import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { IconWater, IconCyber, IconSensors, IconCompliance } from "../brand/icons";
import { getImage } from "../brand/images";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const img = getImage("water-data-center-cooling");

const DataCenterWater = () => (
  <Layout>
    <SEOHead title="Data Center Water Infrastructure | AuditIQ CyberWater" path="/data-center-water"
      description="AuditIQ CyberWater protects atmospheric water generation, cooling loops, pumps, and valves inside modern data centers." />
    <PageHeader eyebrow="Data Center" title="CyberWater for critical cooling infrastructure."
      subtitle="Protect atmospheric water generators, cooling loops, and pump systems with zero-trust device identity and multi-party command authorization." />
    <section className="max-w-[1400px] mx-auto px-6 py-14 grid lg:grid-cols-[1fr_1fr] gap-10 items-start">
      <div className="panel-elev overflow-hidden">
        <img src={img.src} alt={img.alt} className="w-full aspect-[16/10] object-cover opacity-90" />
      </div>
      <div className="space-y-5">
        {[
          { I: IconWater, t: "Atmospheric Water Generation", d: "Sensor integrity and command validation for AWG units feeding cooling loops." },
          { I: IconCyber, t: "Zero-Trust Device Identity", d: "Every PLC, pump, valve, and sensor authenticated continuously." },
          { I: IconSensors, t: "Sensor Trust Scoring", d: "Pressure, flow, humidity, dew-point — spoof-aware scoring and alerts." },
          { I: IconCompliance, t: "Multi-Party Control", d: "Shutdowns and configuration changes require dual operator + AuditIQ policy approval." },
        ].map(({ I, t, d }) => (
          <div key={t} className="panel p-5 flex gap-4">
            <div className="shrink-0"><I size={26} /></div>
            <div><div className="font-display text-lg">{t}</div>
              <div className="text-sm text-cream-dim mt-1">{d}</div></div>
          </div>
        ))}
        <Link to="/contact"><Button className="btn-gold h-11 px-5" data-testid="dc-contact-btn">Scope a CyberWater pilot →</Button></Link>
      </div>
    </section>
  </Layout>
);

export default DataCenterWater;
